<script lang="ts" setup>

import {computed, watch} from "vue";
import router from "@/router/router.ts";
import {useWorkflowStore} from "@/stores/workflow.store.ts";
import {useSynchroStore} from "@/stores/synchro.store.ts";
import {Source} from "@/domain/type/source.type.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";

const workflowStore = useWorkflowStore()
const synchroStore = useSynchroStore()
const isCompanyUsersPage = computed(() => router.currentRoute.value.name === RouteEnum.CompanyUsers)
const companyContext = computed(() => {
  const currentRoute = router.currentRoute.value
  if (currentRoute.name === RouteEnum.CompanyUsers) {
    const sourceLeft = String(currentRoute.query.source ?? '').toLowerCase() as Source
    const sourceRight = String(currentRoute.query.target ?? '').toLowerCase() as Source
    const siret = String(currentRoute.params.siret ?? '')
    const isEvaAmmonPair = (sourceLeft === Source.EVA && sourceRight === Source.AMMON)
      || (sourceLeft === Source.AMMON && sourceRight === Source.EVA)

    return siret && isEvaAmmonPair ? {siret, sourceLeft, sourceRight} : null
  }

  const isEvaAmmonPair = (synchroStore.sourceLeft === Source.EVA && synchroStore.sourceRight === Source.AMMON)
    || (synchroStore.sourceLeft === Source.AMMON && synchroStore.sourceRight === Source.EVA)
  if (synchroStore.type !== SynchroType.COMPANIES || currentRoute.name !== RouteEnum.Fusion || !isEvaAmmonPair) {
    return null
  }

  const evaDetails = synchroStore.sourceLeft === Source.EVA
    ? synchroStore.details?.src1
    : synchroStore.details?.src2
  const siret = evaDetails?.find(detail => detail.label.toLowerCase().includes('siret'))?.val
  return null === siret || undefined === siret
    ? null
    : {siret: String(siret), sourceLeft: synchroStore.sourceLeft, sourceRight: synchroStore.sourceRight}
})

watch(isCompanyUsersPage, isUsersPage => {
  if (!isUsersPage || !companyContext.value) return
  workflowStore.type = SynchroType.COMPANIES
  workflowStore.companyId = companyContext.value.siret
  synchroStore.sourceLeft = companyContext.value.sourceLeft
  synchroStore.sourceRight = companyContext.value.sourceRight
}, {immediate: true})

</script>

<template>
  <div id="stepper" class="d-flex justify-center">
    <v-stepper
      v-if="workflowStore.config"
      v-model="router.currentRoute.value.name"
      class="stepper"
      non-linear
      width="500"
    >
      <v-stepper-header class="d-flex justify-space-around">
        <div v-for="(stepperItem) in workflowStore.config.getStepperItems()" :key="stepperItem.route">
          <v-stepper-item
            :icon="stepperItem.icon"
            :title="stepperItem.title"
            :value="stepperItem.route"
            editable
            @click="stepperItem.action()"
          />
          <v-divider/>
        </div>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<style scoped>
.stepper {
  box-shadow: none !important;
  border-bottom: none !important;
}
</style>
